export default __webpack_public_path__ + "static/versus-8750ca6835471fd981549b4a369b1099.png";